export default function SupportPage() {
  return <div data-testid="page-support">Support</div>;
}
